import React from 'react';
import BlackCheckMarkIcon from 'app/assets/svgIcons/BlackCheckMarkIcon';
import styles from './AudienceStrategicAlignmentField.module.scss';

interface AudienceDropdownPortalProps {
  audienceOptions: string[];
  selectedAudiences: string[];
  onToggleAudience: (audience: string) => void;
}

export const AudienceDropdownPortal: React.FC<AudienceDropdownPortalProps> = ({
  audienceOptions,
  selectedAudiences,
  onToggleAudience
}) => {
  return (
    <div
      className={`audience-dropdown-portal ${styles.audienceDropdownMenu}`}
      onClick={e => e.stopPropagation()}
    >
      {audienceOptions.length === 0 ? (
        <div className={styles.emptyState}>No audiences available</div>
      ) : (
        audienceOptions.map(audience => (
          <div
            key={audience}
            className={`${styles.dropdownOption} ${
              selectedAudiences.includes(audience) ? styles.selected : ''
            }`}
            onClick={e => {
              e.stopPropagation();
              onToggleAudience(audience);
            }}
          >
            <span className={styles.optionText}>{audience}</span>
            <span className={styles.checkmarkContainer}>
              {selectedAudiences.includes(audience) && (
                <BlackCheckMarkIcon width={18} height={14} />
              )}
            </span>
          </div>
        ))
      )}
    </div>
  );
};
